// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Cvca_{display:-ms-flexbox;display:flex;-ms-flex-flow:row wrap;flex-flow:row wrap;-ms-flex-align:baseline;align-items:baseline}.Cvca_ .row{-ms-flex-preferred-size:100%;flex-basis:100%;-ms-flex-align:baseline;align-items:baseline;-webkit-column-gap:30px;-moz-column-gap:30px;column-gap:30px;margin-left:0;margin-right:0}.Cvca_ .col,.Cvca_ .col-6{padding-left:0;padding-right:0}.Cvca_ .col-6{-ms-flex-preferred-size:calc(50% - 15px);flex-basis:calc(50% - 15px)}", ""]);
// Exports
exports.locals = {
	"addPayerForm": "Cvca_"
};
module.exports = exports;
